import process from "process";
import { Buffer } from "buffer";

window.process = process;
window.Buffer = Buffer;
